// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bn-4";
export var collapsed = "_bn-1";
export var headerBar = "_bn-0";
export var leftHeaderContent = "_bn-3";
export var subjectContainer = "_bn-2";